import { Typography } from "@material-ui/core";
import React, { PureComponent, useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  ComposedChart,
} from "recharts";
import constants from "src/constants";

export default ({ data, dataKey }) => {
  const [dim, setDim] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const lg = dim.width > 960;
  const md = dim.width < 960 && dim.width > 600;
  const sm = dim.width < 600;
  const graphHeight = lg
    ? dim.width / 3.8
    : md
    ? dim.width / 2.1
    : dim.width / 1.1;
  const barSize = lg ? 32 : md ? 20 : 4;

  useEffect(() => {
    function handleWindowResize() {
      const { innerWidth, innerHeight } = window;
      let winSize = { width: innerWidth, height: innerHeight };
      setDim(winSize);
    }
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <>
      <div style={{ position: "relative", marginTop: 5 }}>
        <Typography
          sx={{
            color: "#979797",
            position: "absolute",
            top: -15,
            left: 35,
          }}
        >
          kWh
        </Typography>
        <ResponsiveContainer width="100%" height={graphHeight}>
          <BarChart
            data={data}
            margin={{
              top: 40,
              right: 30,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              axisLine={{ stroke: "#99D7CF", strokeWidth: 0 }}
              dataKey={dataKey}
              tickLine={false}
              tickMargin={10}
              fontFamily="Futura PT Book"
            />
            <YAxis
              axisLine={{ stroke: "#B2B2B2", strokeWidth: 1 }}
              tickLine={false}
              tickMargin={10}
              fontFamily="Futura PT Book"
            />
            {/* <YAxis
              axisLine={{ stroke: "#B2B2B2", strokeWidth: 1 }}
              tickLine={false}
              tickMargin={10}
              fontFamily="Futura PT Book"
              dataKey={"kWh"}
              tick={<CustomizedAxisTick />}
              unit={"$"}
              tickCount={6}
            /> */}
            <Bar
              animationDuration={constants.graphAnimation}
              dataKey="usage"
              label={<CustomizedLabel sm={sm} md={md} lg={lg} />}
              barSize={barSize}
              fill="#FFD27D"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

const CustomizedLabel = (props) => {
  const { x, y, stroke, value, sm, md, lg } = props;
  if (value) {
    return (
      <>
        <rect
          rx={8}
          ry={8}
          x={x - 8}
          y={y - 30}
          radius={8}
          width="45"
          height="23"
          fill="#E6EDF2"
        />
        <text
          fontSize={md ? 12 : 12}
          fontWeight={600}
          x={x}
          y={y}
          dy={-15}
          dx={12}
          fill={stroke}
          fontFamily="Futura PT Book"
          textAnchor="middle"
        >
          {value}
        </text>
      </>
    );
  } else {
    return null;
  }
};

const CustomizedAxisTick = (props) => {
  const { x, y, stroke, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        fontFamily="Futura PT Book"
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
      >
        {/* {payload.value} */}
      </text>
    </g>
  );
};
